import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import logoCredicuotas from '../../images/logo_credicuotas_desktop.svg';
import { route } from '../navigation/routes';
import {
  PRIVACY, TERMS, AUTOGESTION, COMMERCE, JOBS_URL,
} from '../../api/env';
import safeGetEnv from '../../prerender';
import { getHomeSocials } from '../pages/home/commons/homeData';
import i18n from './i18n';
import '../../assests/css/footerStyle.css';

const Footer = () => {
  const socialNetworks = getHomeSocials();
  const PRIVACY_LINK = safeGetEnv(PRIVACY);
  const TERMS_LINK = safeGetEnv(TERMS);
  const COMMERCE_LINK = safeGetEnv(COMMERCE);
  const CLIENT_LINK = safeGetEnv(AUTOGESTION);
  const JOBS_LINK = safeGetEnv(JOBS_URL);

  const [hide, setHide] = useState(false);
  const location = useLocation();
  const pathToExcludeFooter = [
    route.whatsapp.toLowerCase(),
    route.uber.toLowerCase(),
    route.recharge.toLowerCase(),
    route.services.toLowerCase(),
    route.cellphoneRecharge.toLowerCase(),
  ];

  const footerColumns = [
    {
      title: i18n.footerColumnCredicuotas,
      offsetLeft: true,
      items: [
        { label: i18n.footerWe, link: route.us },
        { label: i18n.footerBuyOnline, link: route.buyNowPayLater, hidden: true },
        // Comercios físicos dado de baja: sin <a>, para no dejar un link crawleable a un 404.
        // { label: i18n.footerBuyCommerce, link: route.physicalCommerce },
        { label: i18n.footerPayServices, link: route.payServices },
        { label: i18n.footerBlog, link: route.blog },
        { label: i18n.footerHelp, link: route.help },
        {
          label: i18n.footerWorkWithUs, link: JOBS_LINK, external: true, rel: 'noopener noreferrer',
        },
        { label: i18n.footerInvestors, link: route.investors },
      ],
    },
    {
      title: i18n.footerColumnAccess,
      offsetLeft: true,
      items: [
        {
          label: i18n.footerClient, link: CLIENT_LINK, external: true, rel: 'noopener noreferrer',
        },
        {
          label: i18n.footerCommerce, link: COMMERCE_LINK, external: true, rel: 'noopener noreferrer',
        },
      ],
    },
    {
      title: i18n.footerColumnLegal,
      items: [
        {
          label: i18n.footerPrivacy, link: PRIVACY_LINK, external: true, rel: 'noopener noreferrer nofollow',
        },
        { label: i18n.footerConsumerDefense, link: route.consumerProtection, rel: 'nofollow' },
        { label: i18n.footerContract, link: route.contracts, rel: 'noopener noreferrer nofollow' },
        {
          label: i18n.financeUserInformation,
          link: route.financeUserInformation,
          rel: 'nofollow',
        },
        {
          label: i18n.footerConditions, link: TERMS_LINK, external: true, rel: 'noopener noreferrer nofollow',
        },
        { label: i18n.footerRepentanceButton, link: route.cancelCredit, rel: 'nofollow' },
        {
          label: i18n.footerUnsuscribeButton,
          link: route.unsubscribeInformation,
          rel: 'nofollow',
        },
      ],
    },
  ];

  const init = () => {
    const hideFooter = pathToExcludeFooter.includes(location.pathname.toLowerCase());
    setHide(hideFooter);
  };

  useEffect(() => init(), [location.pathname]);

  return (
    <div>
      {!hide && (
        <Box className="boxFooter">
          <Box className="footerContent">
            <Grid container spacing={{ xs: 2, md: 4 }}>
              <Grid item xs={12} md={4} lg={3}>
                <a href={route.home} style={{ textDecoration: 'none' }}>
                  <img
                    src={logoCredicuotas}
                    alt={i18n.credicuotas}
                    className="footerLogo"
                  />
                </a>
                <Typography className="footerDescription">
                  {i18n.footerDescription}
                </Typography>
              </Grid>
              {footerColumns.map((column) => (
                <Grid
                  item
                  xs={12}
                  sm={4}
                  md
                  key={column.title}
                  className={column.offsetLeft ? 'footerColumnOffset' : undefined}
                >
                  <Typography className="footerColumnTitle">
                    {column.title}
                  </Typography>
                  <ul className="footerLinkList">
                    {column.items.map((item) => (
                      <li key={item.label} className={item.hidden ? 'ocultar' : undefined}>
                        {/* eslint-disable-next-line react/jsx-no-target-blank */}
                        <a
                          href={item.link}
                          className="footerLink"
                          target={item.external ? '_blank' : undefined}
                          rel={item.rel}
                        >
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </Grid>
              ))}
            </Grid>
            <Box className="footerSocial">
              <Typography className="footerFollowUs">
                {i18n.footerFollowUs}
              </Typography>
              <Box className="footerSocialRow">
                {socialNetworks.map(({
                  id, label, href, Icon,
                }) => (
                  <a
                    key={id}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="footerSocialLink"
                  >
                    <Icon />
                  </a>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default Footer;
